<template>
  <div>
    <div class="card-container">
      <div class="card-title">
        数据筛选
      </div>
      <div class="card-content">
        <a-form ref="searchForm" :form="form">
          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="区域"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-cascader
                  v-decorator="['areaContain']"
                  :options="options"
                  :load-data="loadData"
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区"
                  change-on-select
                  @change="onAreaChange"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="小区"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-select
                  v-decorator="['estate']"
                  allow-clear
                  placeholder="全部"
                  show-search
                  option-filter-prop="children"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="手机号" v-bind="formItemLayout">
                <a-input
                  v-decorator="['cellPhone']"
                  allow-clear
                  placeholder="请输入手机号搜索"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="昵称" v-bind="formItemLayout">
                <a-input
                  v-decorator="['userName']"
                  allow-clear
                  placeholder="请输入昵称"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="发布时间"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-range-picker v-model="publishDate" class="w100" />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6"></a-col>
            <a-col class="search-item" :span="12" align="right">
              <a-button type="primary" class="" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetForm">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container">
      <div class="">
        <a-row>
          <!-- <a-col :span="12">
            审核列表
          </a-col> -->
          <a-col>
            <div style="background-color: #f4f5f7; margin-bottom: 20px;">
              <a-button
                :class="btnShow == null ? 'linkmr' : 'mr8'"
                :type="btnShow == null ? 'link' : 'text'"
                @click="findState()"
              >
                全部留言
              </a-button>
              <a-button
                :class="btnShow == 0 ? 'linkmr' : 'mr8'"
                :type="btnShow == 0 ? 'link' : 'text'"
                @click="findState(0)"
              >
                待回复
              </a-button>
              <a-button
                :class="btnShow == 1 ? 'linkmr' : 'mr8'"
                :type="btnShow == 1 ? 'link' : 'text'"
                @click="findState(1)"
              >
                已回复
              </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="data"
          :row-key="record => Math.random() * 10000"
          :loading="loading"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <template slot="orderNo" slot-scope="text, record">
            <a-tooltip>
              <template slot="title">
                <div style="font-size:12px">
                  昵称:{{ record.userName }} 手机号:{{ record.cellPhone }}
                </div>
              </template>

              <img :src="record.path" alt="" style=" border-radius: 50%;" />
              <div style="display: inline-block;padding-left:5px"> {{ record.userName }}</div>
            </a-tooltip>
          </template>

          <template slot="images" slot-scope="text, record">
            <div
              @mouseover="mouseOver(record)"
              @mouseleave="mouseLeave(record)"
              style=" display: flex;justify-content: space-between;"
            >
              <div style="display: flex; flex-direction: column;justify-content: center;">
                <div class="scope_txt">
                  {{ record.content }}
                </div>
                <viewer class="item-img_list" :images="record.images">
                  <a
                    v-for="(val, key) in record.images"
                    :key="key"
                    href="javascript:;"
                  >
                    <img class="img-item" :src="val" :images="val" v-if="val" />
                  </a>
                </viewer>
              </div>

              <div v-if="record.show" @click="onClick(record)" class="unfold">
                >
              </div>
            </div>
          </template>
          <template slot="handleContent" slot-scope="text, record">
            <div style=" display: flex;justify-content: space-between;">
              <div>
                <div class="scope_txt">
                  {{
                    record.handleContent
                  }}
                </div>
                <viewer class="item-img_list" :images="record.img">
                  <a
                    v-for="(val, key) in record.img"
                    :key="key"
                    href="javascript:;"
                  >
                    <img class="img-item" :src="val" :images="val" v-if="val" />
                  </a>
                </viewer>
              </div>

              <!-- <div v-if="record.show" @click="onClick(record)" class="unfold">
                >
              </div> -->
            </div>
          </template>
          <template slot="state" slot-scope="text, record">
            <div v-show="record.state == 0">
              待回复
            </div>
            <div v-show="record.state == 1">
              已回复
            </div>

          </template>
          <template slot="operate" slot-scope="text, record">
            <a-button
              v-show="record.state == 1"
              type="link"
              size="small"
              @click="look(record)"
            >
              修改
            </a-button>
            <a-button
              v-show="record.state == 0"
              type="link"
              size="small"
              @click="look(record,'回复')"
            >
              回复
            </a-button>
            <a-button v-show="record.state == 1" type="link" size="small" @click="del(record.id)">
              删除
            </a-button>
          </template>
        </a-table>
      </div>
    </div>
    <a-modal
      v-model="deleteVisible"
      ok-text="确定"
      cancel-text="取消"
      class="comModal"
      @ok="deleteModal"
    >
      <div class="dlContent">
        <icon-font type="iconShape" class="dlIcon"></icon-font>
        <span class="dlTitle">提示</span>
        <div class="dlMain">
          是否确定删除此留言？
        </div>
      </div>
    </a-modal>
    <!-- <a-modal v-model="picVisible" :footer="null">
      <img :src="picSrc" />
    </a-modal> -->
    <a-modal v-model="Visible" :footer="null">
      <div>{{ VisibleList.content }}</div>
      <div style="display: flex;flex-wrap: wrap;">
        <div
          v-for="(item, index) in VisibleList.images"
          :key="index"
          style="margin-right:5px"
        >
          <img :src="item" v-if="item" style="width:100px;height:100px" />
        </div>
      </div>
    </a-modal>
    <a-modal v-model="picVisible" :title="title" :footer="null">
      <!-- @submit="handleSubmit" -->
      <a-form
        :form="modelForm"
        @cancel="handleAdvertCancel"
        destroyOnClose="true"
      >
        <a-form-item
          label="回复内容"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <a-input
            v-model="desc"
            placeholder="请填写留言回复内容"
            type="textarea"
            rows="5"
            :max-length="100"
            allow-clear
          />
        </a-form-item>

        <a-form-item
          label=" 相关照片"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <div>
            <!-- ref="advertFileUpload"
                  v-decorator="[
                    'advertFileList',
                    { rules: [{ required: true, message: '请上传图片' }] }
                  ]" -->
            <a-upload
              :show-upload-list="true"
              list-type="picture-card"
              :file-list="advertFileList"
              :before-upload="advertBeforeUpload"
              :remove="removePicture"
              @preview="handleAdvertPreview"
              @change="handleAdvertChange"
            >
              <div v-if="advertFileList.length < 3">
                <a-icon type="plus" />
                <div>
                  上传图片
                </div>
              </div>
            </a-upload>
            <div class="upload-tip">
              <a-icon
                class="tip-icon"
                type="info-circle"
              />最多可上传1张，大小不超过10M，格式为png，jpeg，jpg。
            </div>
            <!-- <a-modal
                  :visible="advertVisible"
                  :footer="null"
                  @cancel="handleAdvertCancel"
                >
                  <img class="w100" :src="advertImage">
                </a-modal> -->
          </div>
        </a-form-item>

        <a-form-item
          :wrapper-col="{ span: 24 }"
          class="bottomBtn"
          style="    text-align: center;"
        >
          <a-button class="mr16" @click="handleAdvertCancel" style="margin-right: 20px;">
            取消
          </a-button>
          <a-button type="primary" html-type="submit" @click="save">
            提交
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {
  iconFontComponent,
  getArea,
  getEstate
} from "@/components/mixins/mixins.js";
import { getList, save ,del } from "@/api/messageBoard";

export default {
  mixins: [iconFontComponent, getArea, getEstate],
  data() {
    return {
      areaContain: [],
      options: [],

      estate: null,
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },

      stateCount: {},
      region: [],
      areas: [],
      form: this.$form.createForm(this),
      uploadTime: [],
      loading: false,
      columns: [
        {
          title: "用户信息",
          dataIndex: "orderNo",
          scopedSlots: { customRender: "orderNo" },
          width: 100
        },
        {
          title: "留言内容",
          dataIndex: "images",
          scopedSlots: { customRender: "images" },
          width: 150
        },

        {
          title: "留言时间",
          dataIndex: "createTime",
          width: 100
        },
        {
          title: "平台回复",
          dataIndex: "handleContent",
          width: 100,
          scopedSlots: { customRender: "handleContent" }
        },
        {
          title: "回复时间",
          dataIndex: "handleTime",
          width: 100
        },

        {
          title: "回复状态",
          width: 80,
          scopedSlots: { customRender: "state" }
        },
        {
          title: "操作",
          width: 100,
          scopedSlots: { customRender: "operate" }
        }
      ],
      data: [],
      pagination: {
        pageNo: 1,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => "共" + total + "条记录",
        pageSizeOptions: ["10", "20", "30", "40"],
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },

      deleteVisible: false,
      delId: "",
      picSrc: "",
      picVisible: false,
      Visible: false,
      VisibleList: {},
      btnShow: null,
      publishDate: [],
      modelForm: {},
      desc: "",
      advertFileList: [],
      id:'',
      title:''
    };
  },
  mounted() {
    this.getArea("", 2, null, true);
    this.getTableData();
  },
  methods: {
    mouseOver(e) {
      e.show = true;
    },
    mouseLeave(e) {
      e.show = false;
    },
    onClick(e) {
      this.VisibleList = e;

      this.Visible = true;
    },
    findState(e) {
      this.btnShow = e;
      this.getTableData(e)
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true);
    },

    onAreaChange(value, obj) {
      this.estateList = [];
      this.estate = undefined;
      if (value.length < 4) {
        this.getEstate(value);
      } else if (value.length === 4) {
        this.getEstate(null, value[3]);
      }
    },

    showPicture(url) {
      this.picSrc = url;
      this.picVisible = true;
    },
    toSearch() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },
    resetForm() {
      this.state = -1;
      this.form.resetFields();
      this.pagination.pageNo = 1;
      this.getTableData();
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize;
      this.pagination.pageNo = pagination.current;
      this.getTableData();
    },
    getTableData(val) {
      const pa = this.form.getFieldsValue();
      const param = {};
      param.queryParams = {};
      param.page = this.pagination.pageNo;
      param.pageSize = this.pagination.pageSize;
      param.queryParams.state = val;
      param.queryParams.estateId = pa.estateId;
      param.queryParams.cellPhone = pa.cellPhone;
      param.queryParams.userName = pa.userName;
      param.queryParams.estateId = pa.estate;

      if (this.publishDate.length !== 0) {
        param.queryParams.startTime =
          this.publishDate[0].format("YYYY-MM-DD") + " 00:00:00";
        param.queryParams.endTime =
          this.publishDate[1].format("YYYY-MM-DD") + " 23:59:59";
      }
      this.loading = true;
      // this.$httpPost(this.$basePath.getList, param)
      getList(param)
        .then(res => {
          res.result.data.forEach(dat => {
            dat.images = dat.paths ? dat.paths.split(",") : [];
            dat.img = dat.handlePaths ? dat.handlePaths.split(",") : [];
            dat.show = false;
          });
          this.data = res.result.data;
          this.pagination.total = res.result.totalCount;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    lookInfo(id) {
      this.$router.push({
        path: "/scoreReview/info",
        query: {
          id: id,
          status: "view"
        }
      });
    },
    look(e,title) {
      this.title = title ? '添加留言回复' :'修改留言回复'
      this.picVisible = true;
      this.advertFileList = [];
      this.desc = e.handleContent;
      this.id = e.id
      e.handlePaths.split(",").forEach(d => {
        this.advertFileList.push({
          uid: d,
          name: d,
          status: "done",
          url: d
        });
      });
    },
    handleAdvertPreview(file) {
      this.advertImage = file.url || file.thumbUrl;
      this.advertVisible = true;
    },
    handleAdvertChange({ file, fileList }) {
      if (this.advertFileList.length == 3) {
        return false;
      }
      var formdata = new FormData();
      formdata.append("file", file);
      var config = {
        headers: { "Content-Type": "multipart/form-data" }
      };

      this.$httpPost(this.$basePath.uploadImage, formdata, config).then(res => {
        this.imgUp = res.result;
        this.$message.success("上传成功！");

        fileList.forEach(item => {
          if (item.uid === file.uid) {
            Object.assign(item, {
              // 第二个参数覆盖第一个参数对象相同的数据，合并对象
              url: res.result
            });
          }
        });

        this.advertFileList = fileList;
      });
    },
    // handleAdvertChange ({ fileList }) {
    //   this.advertFileList = fileList
    // },
    advertBeforeUpload(file) {
      if (this.advertFileList.length >= 3) {
        this.$message.error("最多可上传3张图片！");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      const isType =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isLt2M) {
        this.$message.error("每张图片大小不能超过10M！");
        return false;
      }
      if (!isType) {
        this.$message.error("请选择png，jpeg，jpg格式图片上传！");
        return false;
      }
      return false;
    },
    removePicture(obj) {
      if (obj.uid) {
        const params = {};
        params.id = obj.uid;
        delPicture(params).then(res => {
          this.form.setFieldsValue({
            advertFileList: []
          });
        });
      }
    },
    handleAdvertCancel() {
      (this.picVisible = false), (this.desc = ""), (this.advertFileList = []);
    },
    save() {
      let paths = [];
      this.advertFileList.forEach(d => {
        paths.push(d.url);
      });

      const param = {
        id:this.id,
        handlePaths: paths.join(","),
        handleContent: this.desc
      };
      save(param).then(res => {
        if(res.code == 0){
          this.picVisible = false
          this.getTableData()
        }

      });
    },
    del(id) {
      this.deleteVisible = true;
      this.delId = id;
    },
    deleteModal() {
      del({id: this.delId}).then(res=> {
         this.$message.success(res.msg);
         this.toSearch();
         this.deleteVisible = false;
      })

    }
  }
};
</script>
<style scoped>
.linkmr {
  background: #fff;
  margin-right: 8px;
}
.mr8 {
  background-color: rgb(244, 245, 247);
  border: none;
}
.img-item {
  width: 50px;
  height: 50px;
  margin-right: 5px;
}
.down-outlined {
  font-size: 20px;
}
.scope_txt {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.unfold {
  margin-left: 30px;
  min-width: 20px;
  height: 68px;
  background: #f4f5f7;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor:pointer
}
</style>
<style lang="stylus" scoped>
>>>.ant-upload-hint
  width 70%
  margin 4px auto 10px auto
>>>.ant-upload-drag-icon
  margin-top 32px
.upload-select
  width 95%
.upload-list
  margin-top 16px
  overflow hidden
  .upload-item
    float left
    margin 0 10px 20px 0
    display flex
    .detail
      width 144px
      margin-left 5px
      .detail-name
        width 144px
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
    img, video
      width 80px
      height 55px
</style>
<style lang="stylus" scoped>
.dlContent
  .dlIcon
    font-size 30px
  .dlTitle
    vertical-align text-bottom
    padding-left: 10px
    font-size: 16px
    color: #333
    font-weight: 500
  .dlMain
    position absolute
    top 64px
    left 64px
    color #666
    font-size 14px
</style>
